var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.23 0H4.77A4.77 4.77 0 000 4.77v25.46A4.77 4.77 0 004.77 35h25.46A4.77 4.77 0 0035 30.23V4.77A4.77 4.77 0 0030.23 0zm-18.3 27.7a.74.74 0 01-.74.74H8.05a.74.74 0 01-.74-.74V14.52c0-.41.33-.74.74-.74h3.14c.41 0 .74.33.74.74V27.7zm-2.3-15.17a2.98 2.98 0 110-5.97 2.98 2.98 0 010 5.97zm18.74 15.22a.68.68 0 01-.68.68H24.3a.68.68 0 01-.68-.68v-6.18c0-.92.27-4.04-2.42-4.04-2.08 0-2.5 2.14-2.58 3.1v7.13c0 .37-.3.67-.67.68h-3.27a.68.68 0 01-.68-.68v-13.3a.68.68 0 01.68-.68h3.27c.37 0 .68.3.68.68v1.15c.77-1.16 1.91-2.05 4.35-2.05 5.4 0 5.37 5.05 5.37 7.82v6.37z","fill":"currentColor","fillRule":"nonzero"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 35 35"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
